import { cellTarget, defineGameCard, onAppear, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
import { selectedUnitId, slimeDependencies, trail } from './slime-helpers.js';
const overlayPlanning = planningTargets((context, previous) => {
    const hostId = selectedUnitId(previous, 'host');
    return [
        targetStep('host', unitTarget({
            side: 'ally',
            cardinality: { min: 1, max: 1 },
            where: ({ unit }) => unit.traits.includes('SLIME'),
        })),
        targetStep('placement', cellTarget({
            side: 'ally',
            occupancy: 'occupied',
            cardinality: { min: 1, max: 1 },
            where: ({ cell }) => hostId !== undefined
                && cell.occupantId === hostId
                && context.units.some((unit) => unit.instanceId === hostId && unit.cellId === cell.cellId),
        })),
    ];
});
export const OvergulperCard = defineGameCard({
    id: 'overgulper',
    gameplay: {
        type: 'UNIT', cost: 3, baseStats: { attack: 2, health: 2 }, traits: ['SLIME'],
        planning: { ...overlayPlanning, fieldPlacement: { kind: 'overlay', hostStepId: 'host' } },
    },
    presentation: {
        name: 'Верхоглот',
        description: 'След 1. Играется поверх вашего слизня и поглощает его. При появлении получает Щит 1.',
        glyph: {
            colors: ['#10213A', '#5E984F', '#96C653', '#3A624D', '#74AD4C'],
            rows: [
                '....................',
                '........1111........',
                '..11..11222311..11..',
                '.144112255553311551.',
                '..1422215555153551..',
                '...12555555555551...',
                '..1255111111555551..',
                '..1551111111155531..',
                '..1511113351115531..',
                '.122111355551155321.',
                '.124112515154143441.',
                '.124112255521143441.',
                '.1221142552411554441',
                '.1221444224441534441',
                '.1421111111111344441',
                '.142211111111334441.',
                '1244422222222444421.',
                '.111144444444444441.',
                '.....1111111111111..',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeDependencies(),
    // Поглощение host — атомарная overlay placement-транзакция движка (D53+):
    // receiver занимает ячейку host и получает его статы ещё ДО своего Появления.
    abilities: [
        trail(),
        onAppear((ctx) => {
            const self = ctx.self;
            if (self !== undefined)
                ctx.ops.addShield(OvergulperCard.id, self.id, 1, self.id);
        }, { cause: 'played' }),
    ],
    ui: {
        mechanics: ['trail', 'slime_residue', 'absorb'],
        planning: {
            steps: {
                host: { label: 'Выберите слизня-основу' },
                placement: { label: 'Подтвердите занятую ячейку' },
            },
        },
    },
});
//# sourceMappingURL=overgulper.js.map